module.exports = __webpack_public_path__ + "static/media/rcf.f02471a4.png";